"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMBOBOX_SELECTION_TYPES = void 0;
const COMBOBOX_SELECTION_TYPES = exports.COMBOBOX_SELECTION_TYPES = ['manual', 'auto', 'auto-inline'];